const modal = {
  baseStyle: {
    dialog: {
      borderRadius: "xl",
      // O padrão escuro do Chakra (gray.700, azulado) destoa das superfícies zinc do app.
      _dark: { "--modal-bg": "colors.app-card" },
    },
  },
};

export default modal;
